import { useState } from 'react';
import { useProducte } from 'hooks/3cat/useProducte';
// @ts-ignore
import Enllac from 'components/corporatiu/Enllac';
// @ts-ignore
import Icona from 'components/corporatiu/Icona';
import Image from 'next/image';
import { dataResources } from 'utils/constants';
import clsx from 'clsx';
import styles from './peu.module.scss';
import { useViewport } from '../../../hooks/corporatiu/useViewport';

const { basePath } = dataResources;
const imageLoader = ({ src }) => {
    return `${src}`;
};

export default function Peu(props) {
    const { isWebviewActive } = useProducte();
    const { isMobile } = useViewport();
    const [openDropdownCorpo, setOpenDropdownCorpo] = useState(false);
    const [openDropdownContact, setOpenDropdownContact] = useState(false);
    const [openDropdownLlengua, setOpenDropdownLlengua] = useState(false);
    const { estil } = props;

    const stylesDropdownCorpo = clsx({
        [styles.open]: openDropdownCorpo
    });
    const stylesDropdownContact = clsx({
        [styles.open]: openDropdownContact
    });
    const stylesDropdownLlengua = clsx({
        [styles.open]: openDropdownLlengua
    });
    const stylesPeu = clsx({
        [styles.footer_wrapper]: true,
        [styles[estil]]: !!estil
    });

    return isWebviewActive ? (
        <></>
    ) : (
        <>
            <footer data-testid='peu' aria-label='Peu de la CCMA' className={stylesPeu}>
                <div className={styles.footer_pre}>
                    <div className={styles.footer_pre__container}>
                        <div className={styles.footer_pre__3cat}>
                            <Enllac href='/3cat/'>
                                <Image
                                    loader={imageLoader}
                                    unoptimized={true}
                                    src={basePath + '/_resources/logos/3cat.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                    width={97}
                                    height={28}
                                    className={styles.imgM}
                                    loading='lazy'
                                    alt='3Cat'
                                ></Image>
                            </Enllac>
                        </div>
                        <div className={styles.footer_pre__logos}>
                            <ul>
                                <li>
                                    <Enllac href='https://www.3cat.cat/tv3/'>
                                        <Image
                                            loader={imageLoader}
                                            unoptimized={true}
                                            src={basePath + '/_resources/logos/tv3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                            width={36}
                                            height={28}
                                            className={styles.imgM}
                                            loading='lazy'
                                            alt='TV3'
                                        ></Image>
                                    </Enllac>
                                </li>
                                <li>
                                    <Enllac href='https://www.3cat.cat/catradio/'>
                                        <Image
                                            loader={imageLoader}
                                            unoptimized={true}
                                            src={basePath + '/_resources/logos/cr_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                            width={34}
                                            height={30}
                                            className={styles.imgL}
                                            loading='lazy'
                                            alt='Catalunya Ràdio'
                                        ></Image>
                                    </Enllac>
                                </li>
                                <li>
                                    <Enllac href='/3catinfo/'>
                                        <Image
                                            loader={imageLoader}
                                            unoptimized={true}
                                            src={basePath + '/_resources/logos/3catinfo_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                            width={114}
                                            height={23}
                                            className={styles.imgS}
                                            loading='lazy'
                                            alt='Info'
                                        ></Image>
                                    </Enllac>
                                </li>
                                <li>
                                    <Enllac href='https://www.3cat.cat/tv3/sx3/'>
                                        <Image
                                            loader={imageLoader}
                                            unoptimized={true}
                                            src={basePath + '/_resources/logos/sx3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                            width={44}
                                            height={22}
                                            className={styles.imgS}
                                            loading='lazy'
                                            alt='SX3'
                                        ></Image>
                                    </Enllac>
                                </li>
                                <li>
                                    <Enllac href='/3cat/eva/'>
                                        <Image
                                            loader={imageLoader}
                                            unoptimized={true}
                                            src={basePath + '/_resources/logos/eva_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                            width={50}
                                            height={22}
                                            className={styles.imgS}
                                            loading='lazy'
                                            alt='EVA'
                                        ></Image>
                                    </Enllac>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className={styles.footer_main__container}>
                    <div className={`${styles.footer_main__corpo} ${stylesDropdownCorpo}`}>
                        <div
                            className={`${styles.js_desplegable} ${styles.headingPeu}`}
                            onClick={() => setOpenDropdownCorpo(!openDropdownCorpo)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    setOpenDropdownCorpo(!openDropdownCorpo);
                                }
                            }}
                            aria-expanded={isMobile ? openDropdownCorpo : undefined}
                            tabIndex={isMobile ? 0 : undefined}
                            role={isMobile ? 'button' : undefined}
                        >
                            <span id='corporatiu-label' role='heading' aria-level={2}>
                                Corporatiu
                            </span>
                            <span className={styles.drowpdown_icona}>
                                <Icona icona='fletxa_simple_avall' alt='desplegar' isBlanc={true} />
                            </span>
                        </div>
                        <ul aria-labelledby='corporatiu-label'>
                            <li>
                                <Enllac href='/corporatiu/ca/el-grup/'>
                                    <span>El grup</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='/corporatiu/transparencia/'>
                                    <span>Transparència</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='/corporatiu/rs/'>
                                    <span>Responsabilitat social</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/tv3/marato/'>
                                    <span>Fundació La Marató</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='/premsa/'>
                                    <span>Premsa</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/publicitat/ca/'>
                                    <span>Publicitat</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/tv3/sales/'>
                                    <span>Vendes internacionals</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='/corporatiu/transparencia/contractacio/#presentacio-de-projectes-audiovisuals-per-als-mitjans'>
                                    <span>Presentació de projectes</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://epc.3cat.cat/Proveidor/index.jsf'>
                                    <span>Espai Proveïdor - Client</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://epc.3cat.cat/Proveidor/pcontractant/presentacio.jsf'>
                                    <span>Perfil del contractant</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/venda-imatges/'>
                                    <span>Còpia i Venda d&apos;imatges</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://botiga.3cat.cat/'>
                                    <span>Botiga</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://seleccio.3cat.cat/'>
                                    <span>Selecció de personal</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://casting.3cat.cat/'>
                                    <span>Càsting</span>
                                </Enllac>
                            </li>
                        </ul>
                    </div>
                    <div className={`${styles.footer_main__contacte} ${stylesDropdownContact}`}>
                        <div
                            className={`${styles.js_desplegable} ${styles.headingPeu}`}
                            onClick={() => setOpenDropdownContact(!openDropdownContact)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    setOpenDropdownContact(!openDropdownContact);
                                }
                            }}
                            aria-expanded={isMobile ? openDropdownContact : undefined}
                            tabIndex={isMobile ? 0 : undefined}
                            role={isMobile ? 'button' : undefined}
                        >
                            <span id='contacte-label' role='heading' aria-level={2}>
                                Contacta&apos;ns
                            </span>
                            <span className={styles.drowpdown_icona}>
                                <Icona icona='fletxa_simple_avall' alt='desplegar' isBlanc={true} />
                            </span>
                        </div>
                        <ul aria-labelledby='contacte-label'>
                            <li>
                                <Enllac href='/atencio/'>
                                    <span>Atenció a l&apos;audiència</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='/atencio/com-veure-i-escoltar/'>
                                    <span>Com veure&apos;ns i escoltar-nos</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='/visita-les-instalacions/'>
                                    <span>Visita&apos;ns</span>
                                </Enllac>
                            </li>
                        </ul>
                    </div>
                    <div className={`${styles.footer_main__llengua} ${stylesDropdownLlengua}`}>
                        <div
                            className={`${styles.js_desplegable} ${styles.headingPeu}`}
                            onClick={() => setOpenDropdownLlengua(!openDropdownLlengua)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    setOpenDropdownLlengua(!openDropdownLlengua);
                                }
                            }}
                            aria-expanded={isMobile ? openDropdownLlengua : undefined}
                            tabIndex={isMobile ? 0 : undefined}
                            role={isMobile ? 'button' : undefined}
                        >
                            <span id='llengua-label' role='heading' aria-level={2}>
                                Llengua
                            </span>
                            <span className={styles.drowpdown_icona}>
                                <Icona icona='fletxa_simple_avall' alt='desplegar' isBlanc={true} />
                            </span>
                        </div>
                        <ul aria-labelledby='llengua-label'>
                            <li>
                                <Enllac href='/angles-i-llengues/'>
                                    <span>Promoció de la llengua</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://esadir.cat/'>
                                    <span>ésAdir</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='/3cat/aran/'>
                                    <span>Espai de l&apos;aranès</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='/bon-dia/'>
                                    <span>Bon dia. Directori de mitjans en llengua catalana</span>
                                </Enllac>
                            </li>
                            <li>
                                <Enllac href='https://www.3cat.cat/llibredestil/'>
                                    <span>Llibre d&apos;estil</span>
                                </Enllac>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.footer_main__troba}>
                        <div className={styles.headingPeu} id='trobans-label' role='heading' aria-level={2}>
                            Troba&apos;ns a
                        </div>
                        <ul aria-labelledby='trobans-label'>
                            <li className={styles.footer_main__boto}>
                                <Enllac href='/atencio/com-veure-i-escoltar/mobils-i-tauletes/'>
                                    <div className={styles.footer_main__ico__smartphone}>
                                        <div className={styles.footer_main__ico}>
                                            <Image
                                                loader={imageLoader}
                                                unoptimized={true}
                                                src='https://statics.3cat.cat/recursos/3cat/icones/smartphone.svg'
                                                loading='lazy'
                                                width={24}
                                                height={24}
                                                alt='icona mòbils'
                                                aria-hidden='true'
                                            ></Image>
                                        </div>
                                    </div>
                                    <div>Mòbils i tauletes</div>
                                </Enllac>
                            </li>
                            <li className={styles.footer_main__boto}>
                                <Enllac href='/atencio/com-veure-i-escoltar/televisors-connectats/'>
                                    <div className={styles.footer_main__ico__smarttv}>
                                        <div className={styles.footer_main__ico}>
                                            <Image
                                                loader={imageLoader}
                                                unoptimized={true}
                                                src='https://statics.3cat.cat/recursos/3cat/icones/smarttv.svg'
                                                loading='lazy'
                                                width={26}
                                                height={20}
                                                alt='icona televisió connectada'
                                                aria-hidden='true'
                                            ></Image>
                                        </div>
                                    </div>
                                    <div>Televisions connectades</div>
                                </Enllac>
                            </li>
                            <li className={styles.footer_main__boto}>
                                <Enllac
                                    href='/butlletins/'
                                    className={`${styles.footer_main__boto_ajuda} ${styles.footer_main__boto_butlletins}`}
                                >
                                    <div className={styles.footer_main__ico__smarttv}>
                                        <div className={styles.footer_main__ico}>
                                            <Image
                                                loader={imageLoader}
                                                unoptimized={true}
                                                src='/_resources/icones/blanc/sobre.svg'
                                                loading='lazy'
                                                width={26}
                                                height={26}
                                                alt='icona sobre correu'
                                                aria-hidden='true'
                                            ></Image>
                                        </div>
                                    </div>
                                    <div>Butlletins</div>
                                </Enllac>
                            </li>
                            <li className={styles.footer_main__boto}>
                                <Enllac href='https://www.3cat.cat/ajuda/3cat/' className={styles.footer_main__boto_ajuda}>
                                    <div className={styles.footer_main__ico__smarttv}>
                                        <div className={styles.footer_main__ico}>
                                            <Image
                                                loader={imageLoader}
                                                unoptimized={true}
                                                src='https://statics.3cat.cat/recursos/3cat/icones/ic_info_contorn.svg'
                                                loading='lazy'
                                                width={26}
                                                height={26}
                                                alt='icona televisió connectada'
                                                aria-hidden='true'
                                            ></Image>
                                        </div>
                                    </div>
                                    <div>Ajuda plataforma 3Cat</div>
                                </Enllac>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className={styles.footer_post__container}>
                    <div>
                        <Enllac href='https://www.3cat.cat/avis-legal/'>
                            <span>Avís legal</span>
                        </Enllac>
                        <Enllac href='/canal-etic/'>
                            <span>Canal ètic</span>
                        </Enllac>
                        <Enllac href='https://www.3cat.cat/avis-legal/cookies/'>
                            <span>Cookies</span>
                        </Enllac>
                        <Enllac href='https://www.3cat.cat/avis-legal/privacitat/dades/'>
                            <span>Política de Privacitat</span>
                        </Enllac>
                        <Enllac href='/atencio/accessibilitat/'>
                            <span>Accessibilitat</span>
                        </Enllac>
                        <Enllac href='/atencio/mapaweb/'>
                            <span>Mapa web</span>
                        </Enllac>
                    </div>
                    <div className={styles.footer_post__copy}>© 3Cat</div>
                </div>
            </footer>
        </>
    );
}
